var AdaptiveImage = require("../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "icon-drha.2fcc588f.png","uri@2x": __webpack_public_path__ + "icon-drha.eeaa55a4.png","uri@3x": __webpack_public_path__ + "icon-drha.6f588db0.png",
    width: 20,
    height: 20
});